import { ContextService } from '../../services/context_service';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { getLastDataYear } from '../datenauswertung/helper/getLastDataYear';
// import { getLastYearWithValues } from '../datenauswertung/helper/getLastYearWithValues';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import style from '../../main/main.less';
import { ValidierungHinweise } from '../datenauswertung/elements/ValidierungHinweise';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { getVeranstaltungen } from '../../helpers/getVeranstaltungen';
import { findStandorteTabRouting, getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';

interface StartDashboardProps extends React.ClassAttributes<any> {
    data: any;
    fixedJahr?: number;
    colWidth?: number;
    fontSize?: number;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

export interface StartDashboardState {
    jahr: number;
    jahrMin: number;
    jahrMax: number;
    onlyErrors: boolean;
}

export class StartDashboard extends React.Component<StartDashboardProps, StartDashboardState> {

    constructor(props: any) {
        super(props);
        const konfig = props.data[IDs.ENT_KONFIGURATION];
        const max = Moment().year();
        const jahrMax = getLastDataYear(max, this.props.data, { invalidData: true }) || max;
        // const jahrMax = getLastYearWithValues(this.props.data, null) || Moment().year();
        let jahrMin = 2010;

        if (konfig && konfig[0] && konfig[0].startjahr_datenerfassung && konfig[0].startjahr_datenerfassung > 1900) {
            jahrMin = konfig[0].startjahr_datenerfassung;
        }
        // COCKPIT
        const jahrContext = this.contextService.get('jahr_cockpit');
        const jahrUse = jahrContext || ((this.props.routing && this.props.routing.jahr) ? this.props.routing.jahr : jahrMax);
        // console.log('DASHROUT: ', this.props.routing);
        this.state = {
            onlyErrors: true,
            jahr: this.props.fixedJahr ? this.props.fixedJahr : jahrUse,
            jahrMin: jahrMin,
            jahrMax: jahrMax
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    getColorForLevel(level: string): string {
        switch (level) {
            case 'error':
                return '#a00';
            case 'ok':
                return '#0a0';
            case 'warning':
                return '#88a';
            default:
                return null;
        }
    }

    getIconForLevel(level: string): JSX.Element {
        switch (level) {
            case 'error':
                return <>&#9888;</>;
            case 'ok':
                return <>&#10004;</>;
            case 'warning':
                return <>&#9888;</>;
            default:
                return null;
        }
    }

    render(): JSX.Element {
        if (!this.props.data || !this.props.data.plausibel) {
            return <div>Warte auf Daten ...</div>;
        }
        const fontSize = `${this.props.fontSize ? this.props.fontSize : 12}pt`;
        const styleInfo = { backgroundColor: '#bccae3', color: 'black', fontSize };
        const width = this.props.colWidth ? this.props.colWidth : 500;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <div style={{ padding: 5, backgroundColor: '#eee', display: 'flex', flexDirection: 'row' }}>
                    {this.props.fixedJahr
                        ? <b>{this.props.fixedJahr} &nbsp; &nbsp;</b>
                        :
                        <DatenauswertungJahrauswahlEinzeln
                            jahrMax={this.state.jahrMax}
                            jahrMin={this.state.jahrMin}
                            jahr={this.state.jahr}
                            noFlex={true}
                            onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                        />
                    }
                    <div style={{ marginLeft: 40, paddingTop: 7 }}>Nur Fehler ausgeben</div>
                    <div style={{ marginLeft: 10, paddingTop: 7 }}>
                        <input
                            type='checkbox'
                            checked={this.state.onlyErrors}
                            onChange={(evt: any) => this.setState({ onlyErrors: evt.target.checked })}
                        />
                    </div>
                </div>
                <div className={style.rowContainer} style={{ flexWrap: 'wrap', minHeight: 0, overflowY: 'auto' }}>
                    <div style={{ width, margin: 10 }}>
                        <div className={style.infofield} style={styleInfo}>
                            Plausibilität <b>Stammdaten</b>
                        </div>
                        {this.renderStammdaten()}
                    </div>
                    <div style={{ width, margin: 10 }}>
                        <div className={style.infofield} style={styleInfo}>
                            Plausibilität <b>Energiedaten</b>&nbsp;
                            (Abrechnungsjahr: <b>{this.state.jahr}</b>)
                        </div>
                        {this.renderEnergiedaten()}
                    </div>
                    <div style={{ width, margin: 10 }}>
                        <div className={style.infofield} style={styleInfo}>
                            Plausibilität <b>Konfiguration</b>
                        </div>
                        {this.renderKonfigurationsdaten()}
                    </div>
                </div>
            </div>
        );
    }

    renderEnergiedaten(): JSX.Element | JSX.Element[] {
        const jahr: number = this.state.jahr;
        const dataEnergie: any[] = this.props.data.plausibel[jahr]
            ? this.props.data.plausibel[jahr]
                .filter((item: any) => item.typ === 'energie' && (!this.state.onlyErrors || item.level !== 'ok'))
            : [];

        return dataEnergie.length
            ? dataEnergie.map((item: any, i: number) => this.renderItem(item, `energie_${i}`))
            : this.renderItem({ text: 'Es wurden keine Probleme gefunden', level: 'ok' }, 'energie_0');
    }

    renderItem(item: any, key: string): JSX.Element {
        const routing: any = item.routing || {};
        const backgroundColor = this.getColorForLevel(item.level);
        const entities: string[] = routing.entities || [];
        const hasRouting: boolean = !!routing.path;
        const id: number | string = key.startsWith('konfig_') || key.startsWith('stamm_') ? item.tid : this.state.jahr;
        const validation: any = item.validation || {};
        const tid: number = +Object.keys(((validation || {})[id] || {})[entities[0]] || {}).map((tid: string) => tid)[0] || null;

        let onClick: () => void;
        if (routing.path && routing.standort > 0) {
            let basisRouting, basisTab, standortRoutingFnd;
            if (routing.path[RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX] >= 0) {
                basisRouting = RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX;
                basisTab = RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX;
            } else if (routing.path[RoutingIDs.TABS_DATENEINGABE_CO2_KOMPLEX] >= 0) {
                basisRouting = RoutingIDs.ROUTE_DATENEINGABE_CO2_KOMPLEX;
                basisTab = RoutingIDs.TABS_DATENEINGABE_CO2_KOMPLEX;
            }
            const istVeranstaltung = getVeranstaltungen(this.props.data).find((s: any) => s.tid === routing.standort);
            if (!istVeranstaltung) {
                standortRoutingFnd = basisRouting && basisTab ? findStandorteTabRouting(routing.standort, this.props.data, basisRouting, basisTab) : {};
            } else {
                const tabRoutings = basisRouting && basisTab ? getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab) : [];
                standortRoutingFnd = {
                    path: {
                        ...basisRouting,
                        [basisTab]: tabRoutings.length,
                        terminateOn: basisTab
                    }
                };
            }
            const dateneingabeRouting = {
                standort: routing.standort,
                entities: routing.entities,
                path: { ...routing.path, ...((standortRoutingFnd || {}).path || {}) }
            };
            onClick = () => setTimeout(() => this.props.onRoutingChange(dateneingabeRouting), 0);
        }

        return (
            <div
                className={style.infofield}
                style={{ ...(backgroundColor && { backgroundColor }), cursor: hasRouting ? 'pointer' : 'default' }}
                // onClick={() => hasRouting ? this.props.onRoutingChange({ ...routing, ...(tid && { tid }) }) : null}
                onClick={onClick}
                key={`daten_${key}`}
            >
                <div className={style.rowContainer} style={{ width: '100%' }}>
                    <div
                        style={{
                            fontSize: 30, display: 'flex', flexBasis: '11%', flexDirection: 'column', alignItems: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        {this.getIconForLevel(item.level)}
                    </div>
                    <div style={{ paddingLeft: 5, display: 'flex', flexDirection: 'column', flexBasis: '89%', alignSelf: 'center' }}>
                        <div style={{ paddingRight: 10 }}>{item.text}</div>
                        {id &&
                            <ValidierungHinweise
                                entities={[entities]}
                                id={id}
                                layout3
                                showPriorityColors
                                style={{ marginTop: 5, border: '1px solid #e5e4e4', borderRadius: 3 }}
                                validation={validation}
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }

    renderKonfigurationsdaten(): JSX.Element | JSX.Element[] {
        const jahr: number = this.state.jahr;
        const dataKonfiguration: any[] = this.props.data.plausibel[jahr]
            ? this.props.data.plausibel[jahr]
                .filter((item: any) => item.typ === 'konfiguration' && (!this.state.onlyErrors || item.level !== 'ok'))
            : [];

        return dataKonfiguration.length
            ? dataKonfiguration.map((item: any, i: number) => this.renderItem(item, `konfig_${i}`))
            : this.renderItem({ text: 'Es wurden keine Probleme gefunden', level: 'ok' }, 'konfig_0');
    }

    renderStammdaten(): JSX.Element | JSX.Element[] {
        const jahr: number = this.state.jahr;
        const dataStamm: any[] = this.props.data.plausibel[jahr]
            ? this.props.data.plausibel[jahr]
                .filter((item: any) => item.typ === 'stamm' && (!this.state.onlyErrors || item.level !== 'ok'))
            : [];
        const dataUnternehmen: any[] = this.props.data.plausibel[jahr]
            ? this.props.data.plausibel[jahr]
                .filter((item: any) => item.typ === 'unternehmen' && (!this.state.onlyErrors || item.level !== 'ok'))
            : [];
        const data: any[] = [...dataUnternehmen, ...dataStamm];

        return data.length
            ? data.map((item: any, i: number) => this.renderItem(item, `stamm_${i}`))
            : this.renderItem({ text: 'Es wurden keine Probleme gefunden', level: 'ok' }, 'stamm_0');
    }
}
